import * as React from 'react';
import { useState } from 'react';
import { Reference, Part, PartDefinition, ReferenceAssignmentsRequest, getShortTypeNameString, selectAllPartDefinitions, filterPartDefinitionsForReferenceType, getRefMap, getPartValue, getPartLabel, selectCurrentReference, selectReferenceAssignments, selectAllReferences, loadAllTaxonomyReferences, loadAllReferenceAssignments, clearSelectedReference, setSelectedReference } from '../../../redux/TaxonomyReferenceSlice';
import { setEditReference, selectEditReference, addPartDefinitionChange, getPartDefinitionChanges } from '../../../redux/TaxonomyChangesSlice';
import { useAppSelector, useAppDispatch } from '../../../hooks/index';
import { FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Select, { useEffect } from 'react-select';
import { setIsTaxonomyDirty } from '../../../redux/TaxonomyVersionSlice';
import { Edit } from '../../../redux/MiscSlice';



import './ModalPopUp.css';
import Modal from './Modal';
//import { statSync } from 'node:fs';

interface ddSelection {
    dropdown: string,
    dropdowntype: string,
    part: PartDefinition | null
}

interface ddOption {
    name: string;
    documentation: string;
}

function SelectNewPartModal(props: any) {

    const dispatch = useAppDispatch();

    const [state, setState] = useState<Array<ddSelection>>([{
        dropdown: "",
        dropdowntype: "",
        part: null
    }]);

    const [customName, setCustomName] = useState("");
    const [customDocumentation, setCustomDocumentation] = useState("");

    const partDefinitions = useAppSelector(selectAllPartDefinitions);
    const changedPartDefinitions = useAppSelector(getPartDefinitionChanges);

    const collectAllPartDefinitions = function (): PartDefinition[] {
        var allDefs: PartDefinition[] = [];
        if (partDefinitions) {
            allDefs = allDefs.concat(partDefinitions);
        }
        if (changedPartDefinitions) {
            allDefs = allDefs.concat(changedPartDefinitions);
        }
        allDefs.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) )
        return allDefs;
    }
    const [allPartDefinitions, setAllPartDefinitions] = useState<PartDefinition[]>(collectAllPartDefinitions());

    const currentReference: Reference | null = useAppSelector(selectEditReference);
    const [groupName, setGroupName] = useState(getShortTypeNameString(currentReference ? currentReference.type : "none"));

    const getOptions = function (allPartDefs : PartDefinition[]) : ddOption[] {
        var options: ddOption[] = [];
        if (!allPartDefs) {
            return options;
        }
        if (allPartDefs.length === 0) {
            return options;
        }
        var allDefs = filterPartDefinitionsForReferenceType(currentReference, allPartDefs)
        for (var pd of allDefs) {
            options.push({ name: pd.name, documentation: pd.documentation });
        }
        return options;
    }
    const [selectedOption, setSelectedOption] = useState({ name: "", documentation: "" });


    // Handle Event
    const handleChange = (e: any, action: any) => {

        var ddName: string = action.name;
//        var partName: string = (e.value.indexOf(": ") > 0) ? e.value.split(": ")[1] : e.value.trim();
        var partName: string = e.value;
        var part: PartDefinition | null = null;
        var ddType = "Part";
        var option: ddOption = { name: "", documentation: "" };
        var partDef : PartDefinition | null | undefined = allPartDefinitions.find(po => po.name === partName);
        if (partDef) {
            option = { name: partDef.name, documentation: partDef.documentation };
        }
        setSelectedOption(option);
        var newState = JSON.parse(JSON.stringify(state));
        if (!currentReference) {
            alert("Missing reference for selection processing of " + ddName);
        } else {
            console.log("huh", currentReference);
            var p = currentReference.parts.find(pt => pt.definition.name === partName);
            if (p) {
                part = p.definition;
            } else {
                part = { group: "", name: partName, documentation: "", datatype: "", deprecationDate: "" };
            }
        }


        var index = newState.findIndex((itm: any) => itm.dropdown === ddName);
        var selectedValue = { dropdown: ddName, dropdowntype: ddType, part: part }


        if (index === -1) {
            newState.push(selectedValue)
        } else {
            newState[index] = selectedValue
        }
        newState.sort((a: any, b: any) => a.dropdown.toLowerCase().localeCompare(b.dropdown.toLowerCase()));

        setState(newState);

    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "Name":
                if (!customName || customName.length === 0) {
                    result = false;
                }
                break;
            case "documentation":
                //                if (!documentation || documentation.length === 0) {
                //                    result = false;
                //                }
                break;
        }
        return result;
    }

    const allowsDuplicateParts = (): boolean => {
        return false;
    }


    const setTaxonomyDirty = function () {
        var estate: Edit = {
            IsDirty: true,
            Page: ""
        }
        dispatch(setIsTaxonomyDirty(estate));
    }

    // browse the and save temporarily in redux store
    const handleAddNewPart = (e: any) => {
        if (!currentReference) {
            return;
        }
        var partdef : PartDefinition | null = null;
        //Validate that each dropdown is selected
        for (var itm of state) {
            if (itm.part) {
                partdef = itm.part;
            } else {
                alert(itm.dropdowntype + " is mandatory!")
                return false;
            }
        }
        if (!partdef) {
            alert("selection must include a part!")
            return false;
        }
        var addtnlPart: Part = {
            definition: partdef,
            value: ""
        }
        // saving in AFR slice
        var updatedReference: Reference = {
            type: currentReference.type,
            parts: [...currentReference.parts],
            dirty: true,
            new: currentReference.new
        }
        updatedReference.parts.push(addtnlPart);
        
        // Save the information in redux afr
        dispatch(setEditReference(updatedReference));

        //close modal
        props.onCloseModal("");

    }



    function renderParts(options : any) {

        return (
            <React.Fragment key={'ReferencePartDefinitions'}>

                <Container>
                    <Row xs="1">
                        <Col>
                            <Label ><b>Parts Available for reference type {groupName}:</b></Label>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <Select
                                name={'ReferencePartDefinitions'}
                                onChange={handleChange}
                                autoFocus
                                options={options}
                                isOptionDisabled={(option : any) => option.isdisabled}
                                style={{ width: "25em" }}
                            />

                        </Col>
                    </Row>
                    <br />
                    <br />
                </Container>
            </React.Fragment >
        );
    }

    function generateDropdownValues(allPartDefs : PartDefinition[], updateState: boolean) {

        var render = [];
        var ddState: Array<ddSelection> = [];
        var axe_i: number = 1;
        if (!currentReference ) {
            render.push(<span></span>);
            return render;
        }
        const pmap : any = {};
        for (var part of currentReference.parts) {
            pmap[part.definition.name] = part;
        }
        const filteredOptions = [];
        for (var opt of getOptions(allPartDefs)) {
            if (!pmap.hasOwnProperty(opt.name)) {
                filteredOptions.push(opt);
            }
        }
        const options = filteredOptions.map(opc => ({
            value: opc.name,
            label: opc.name,
            isdisabled: false
        }));

        options.sort((a, b) => a.value > b.value ? 1 : -1);


        // render accounts
        render.push(renderParts(options));
        ddState.push({ dropdown: 'ReferencePartDefinitions', dropdowntype: "Part", part: null })


        if (updateState) {
            setState(ddState);
        }

        return render;

    }

//    const renderPage = generateDropdownValues(false)

    const [renderPage, setRenderPage] = useState(generateDropdownValues(collectAllPartDefinitions(),false));


    React.useEffect(() => {
        var allPartDefs: PartDefinition[] = collectAllPartDefinitions();
        setAllPartDefinitions(allPartDefs);
        setRenderPage(generateDropdownValues(allPartDefs,true));
        setSelectedOption({ name: "", documentation: "" });

    }, [props]);


    React.useEffect(() => {
        var allPartDefs: PartDefinition[] = collectAllPartDefinitions();
        setAllPartDefinitions(allPartDefs);
        setRenderPage(generateDropdownValues(allPartDefs,true));
        setSelectedOption({ name: "", documentation: "" });

    }, [changedPartDefinitions]);

    return (
        <React.Fragment >
            <Modal isOpen={props.isOpen} onClose={props.onCloseModal}>
                <div className="ModalPopUp">
                    <h4>Adding new Reference Part</h4>
                    <br />
                    <br />
                    <Row style={{ width: "100%" }}>
                        <Col >
                            {props.isOpen && renderPage /* generateDropdownValues()*/}
                            <Row xs="1">
                                {selectedOption.name.length > 0
                                    ?
                                    <div style={{ marginTop: "1em", marginRight: "1em", marginLeft: "1em", width: "100%" }} >
                                        <Toast>
                                            <ToastHeader><b>Part Description for {selectedOption.name}</b></ToastHeader>
                                            <ToastBody>{selectedOption.documentation}</ToastBody>
                                        </Toast>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </Row>
                        </Col>

                    </Row>
                    <div>
                        <button onClick={handleAddNewPart} className="btn btn-primary mr-4">
                            Add
                        </button>
                        <button onClick={props.onCloseModal} className="btn btn-primary">
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default SelectNewPartModal;